import { useQuery } from '@tanstack/react-query';
import type { SpecialtyOption } from '@/lib/specialties/types';

/**
 * Hook to fetch distinct specialties from profiles
 * Cached for 10 minutes, stale after 5 minutes
 */
export function useSpecialties() {
  const { data, isLoading, error, refetch } = useQuery<SpecialtyOption[]>({
    queryKey: ['specialties'],
    queryFn: async () => {
      const response = await fetch('/api/specialties');
      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }
      return response.json();
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
    refetchOnWindowFocus: false,
  });

  return {
    data: data ?? null,
    isLoading,
    isStale: false,
    error: error instanceof Error ? error : null,
    refetch,
    mutate: () => {}, // no-op for API compat
  };
}
